import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import StyledTab from '../common/StyledTab';
import StyledTabs from '../common/StyledTabs';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface Props {
    booking: React.ReactNode;
    service: React.ReactNode;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} {...other}>
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

const CustomTab = ({ booking, service }: Props) => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <Box sx={{ width: '100%', padding: 0 }}>
            <Box sx={{ bgcolor: 'black' }}>
                <StyledTabs value={value} onChange={handleChange} centered>
                    <StyledTab label="Appointments" {...a11yProps(0)} />
                    <StyledTab label="Services" {...a11yProps(1)} />
                </StyledTabs>
            </Box>
            <TabPanel value={value} index={0}>
                {booking}
            </TabPanel>
            <TabPanel value={value} index={1}>
                {service}
            </TabPanel>
        </Box>
    );
};
export default CustomTab;
